import * as React from 'react';
import { useState, useEffect } from 'react';
import qs from 'qs';
import styled from 'styled-components';
import { getLocale } from '../utils/pathHelper';
import { ICancellationPolicy } from './types';
import { colors } from '../styles/variables';
import t from './locales';

// ApiClient等を使用せず、意図的に既存の宿実装から独立させている

type IRoomOnBooking = {
  males: number;
  females: number;
  childAges: Array<number>;
}

type ISearchParamsForBackEnd = {
  checkin_date: string,
  checkout_date: string,
  rooms: Array<{ adults: number, child_ages: number[] }>,
}

type IProps = {
  defaultCancellationPolicy?: ICancellationPolicy,
  host: string,
  params?: {
    yadoId: string,
    planId: string,
    checkInDate: string,
    checkOutDate: string,
    rooms: IRoomOnBooking[],
  },
}

function formatSearchParams({ checkInDate, checkOutDate, rooms }: {
  checkInDate: string,
  checkOutDate: string,
  rooms: IRoomOnBooking[],
}): ISearchParamsForBackEnd {
  return {
    checkin_date: checkInDate,
    checkout_date: checkOutDate,
    rooms: rooms.map((room: IRoomOnBooking) => ({
      adults: room.males + room.females,
      child_ages: room.childAges,
    })),
  };
}

const YadoCancellationPolicyView = styled.div`
  table {
    width: 100%;
    td {
      padding: 0.3rem;
    }
    td:last-child {
      text-align: right;
    }
    tr:not(:last-of-type) {
      border-bottom: 1px solid ${colors.gray200};
    }
  }
`;

const ErrorView = styled.div`
  padding: 1em;
  border: 1px solid ${colors.gray300};
  border-radius: 8px;
`;


const YadoCancellationPolicy = ({ defaultCancellationPolicy, host, params }: IProps) => {
  const [isLoading, toggleLoading] = useState(false);
  const [fetchError, setfetchError] = useState(null);
  const [cancellationPolicy, setCancellationPolicy] = useState<ICancellationPolicy|null>(null);

  useEffect(() =>   {
    toggleLoading(true);
    if (defaultCancellationPolicy) {
      setCancellationPolicy(defaultCancellationPolicy);
      return null;
    }
    const { yadoId, planId, checkInDate, checkOutDate, rooms } = params;
    const searchParams = {  checkInDate, checkOutDate, rooms };
    if (!(host &&　yadoId && planId && searchParams)) { return null; }

    const paramsStriing = qs.stringify(formatSearchParams(searchParams), { arrayFormat: 'brackets', encode: false });
    const headers = {
      'X-CLIENT-TYPE': 'web',
      'X-DEVICE-OS': 'web',
      'Accept-Language': getLocale({ underscore: false }),
    };
    fetch(`${host}/api/v1/yados/${yadoId}/plans/${planId}?${paramsStriing}`, {
      headers,
    })
    .then(res => res.json())
    .then(json => {
      setCancellationPolicy(json.roomPlan.plan.cancellationPolicy);
      toggleLoading(false);
    })
    .catch(error => {
      console.error(error);
      setfetchError(error);
      toggleLoading(false);
    });
  }, [])

  if (isLoading) { return <div><i className="fas fa-spin fa-spinner" /></div> }
  if (fetchError != null) { return <ErrorView>Error</ErrorView>; }
  if (!cancellationPolicy || !cancellationPolicy.policies) { return null; }
  const { policies } = cancellationPolicy;
  return (
    <YadoCancellationPolicyView>
      <table>
        <tbody>
          <tr>
            <td>{t.cancellationNoShow()}</td>
            <td>100 %</td>
          </tr>
          {policies.map((policy, index) => (
            <tr key={`policy-${index}`}>
              <td>{policy.period === 0 ? t.cancellationOnTheDay() : t.cancellationXDaysBefore({ day: policy.period })}</td>
              <td>{cancellationPolicy.type === 'percent' ? `${policy.value} %` : `JPY ${policy.value}`}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ marginTop: '0.25rem', fontSize: '0.8em' }}>
        {t.pleaseNoteCancellationsCannotBeMadeAfter180Days()}
      </div>
    </YadoCancellationPolicyView>
  );
}

export default YadoCancellationPolicy;
